import './styles.scss'
import Icon from '@components/Icon'

const CloseButton = ({ action, size = 'xs' }) => (
    <button onClick={action} className="close-button-x" aria-label="close-button-x">
        <Icon type="close" size={size} />
    </button>
)

export default CloseButton
